import axios from 'axios';

// Base URL for API calls
const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? 'https://skyoptimizer.org'  // Adjust if your production domain differs
  : '';  

// Error handling utility
const handleApiError = (error, context) => {
  console.error(`Error in ${context}:`, error);

  if (error.response) {
    // Server responded with error status
    const { status, data } = error.response;
    const message = data?.error || `HTTP ${status} error`;
    throw new Error(message);
  } else if (error.request) {
    // Network error
    throw new Error('Network error - please check your connection');
  } else {
    // Other error
    throw new Error(error.message || 'An unexpected error occurred');
  }
};

// Fetch player SkyBlock profile data
export const getPlayerData = async (username) => {
  if (!username || typeof username !== 'string') {
    throw new Error('Valid username is required');
  }

  try {
    const response = await axios.get(`${API_BASE_URL}/profile?username=${encodeURIComponent(username.trim())}`);
    return response.data;
  } catch (error) {
    handleApiError(error, 'getPlayerData');
  }
};